import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import establishmentReadAction from './establishmentRead.action.json' assert { type: 'json' }

const establishmentReadDefinition = defineReadAutoAction(establishmentReadAction, 'estabelecimento')

export default establishmentReadDefinition